import { AppSelectorService } from '../../shared/services/app-selector/app-selector.service';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

const storedData = "storedData";
@Component({
  selector: 'app-switch-panel',
  templateUrl: './switch-panel.component.html',
  styleUrls: ['./switch-panel.component.scss']
})
export class SwitchPanelComponent implements OnInit {
  currentUserInfo: any;
  apiParams: any = {
    switch_type: "PX_TO_CEE"
  };
  popupRef: any;

  constructor(
    private dialogRef: MatDialogRef<SwitchPanelComponent>,
    private appSelectorService: AppSelectorService,
  ) { }

  ngOnInit() { }

  handleDialogClose() {
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__slideInLeft")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__slideOutLeft");

    setTimeout(() => { this.dialogRef.close(); }, 1000);
  }

  onCustomerEngagementClick() {
    this.handleDialogClose();

    let storedData: any = this.appSelectorService.getCEDataFromLocalStorage();
    if (storedData) {
      if (storedData.timeStamp > Date.now()) {
        window.open(`${storedData.baseUrl}admin/index.php/${storedData.home_dashboard_url}`);
        return;
      }
      this.appSelectorService.removeCEDataFromLocalStorage();
    }

    this.appSelectorService.handleSwitchPanel("switch-panel");
  }
}
